import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { MSW_COMPETENCY_ITEMS } from './mswConstants';

const MswCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="MSW"
            title="MSW CLINICAL COMPETENCY ASSESSMENT"
            items={MSW_COMPETENCY_ITEMS}
            totalPages={5}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default MswCompetency;
